import React from 'react';


// TODO EMail

export const Kontakt = () => {
    return (
        <section className='portfolio-mf sect-pt4 route' id='contact'>
            <main>


                <div className='text-card-container'>
                <h1 className='section-header'>Kontakt</h1>

                    

                <div className="row">
                <div className="col-sm-12">
                    
                            <br/>
                            <span><a href="mailto:info@sophiakundaliniyoga.de">info@sophiakundaliniyoga.de</a></span>
                            <br/>
                            <span>+49 176 500 78 544</span>
                        </div>

                    </div>
                    </div>
            </main>

        </section>

    );
}